module.exports = __webpack_public_path__ + "img/filteredLeads.d2a0d978.svg";